<template>
  <div class="video-page">
    <!-- 页面头部 -->
    <header class="video-header">
      <!-- 返回按钮 -->
      <button class="back-btn" @click="goBack">
        <span class="icon">←</span> 返回
      </button>
      <!-- 视频标题 -->
      <h1 class="page-title">{{ currentVideo.title }}</h1>
    </header>

    <!-- 视频播放器区域 -->
    <section class="video-player-section">
      <div class="video-container">
        <!-- 视频播放器 -->
        <video 
          ref="videoPlayer"
          :src="currentVideo.url" 
          :poster="currentVideo.poster"
          controls
          class="video-player"
          @play="onPlay"
          @pause="onPause"
          @ended="onVideoEnded"
        >
          您的浏览器不支持视频播放。
        </video>
      </div>
      
     视频基本信息
      <div class="video-info">
        <div class="video-meta">
          <div class="author-info">
            <img :src="currentVideo.author.avatar" :alt="currentVideo.author.name" class="author-avatar">
            <div class="author-details">
              <h3 class="author-name">{{ currentVideo.author.name }}</h3>
              <p class="video-stats">{{ currentVideo.views }} 次观看 • {{ currentVideo.uploadTime }}</p>
            </div>
          </div>
        </div> -->
        
        <!-- 视频描述 -->
       <div class="video-description">
          <p>{{ currentVideo.description }}</p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// 导入Vue3的响应式API
import { ref, onMounted, onUnmounted } from 'vue'
// 导入路由相关功能（如果使用Vue Router）
import { useRouter } from 'vue-router'

export default {
  name: 'VideoPage',
  
  setup() {
    // 使用Vue Router（如果项目中有配置）
    const router = useRouter()
    
    // 视频播放器DOM引用
    const videoPlayer = ref(null)
    
    // 当前视频数据（模拟数据，实际应从API获取）
    const currentVideo = ref({
      id: 1,
      title: '示例视频标题',
      url: 'https://www.douyin.com/user/self?from_tab_name=main&modal_id=7321892828202732800', // 替换为实际视频URL
      poster: 'https://via.placeholder.com/800x450/4A90E2/FFFFFF?text=视频封面',
      views: 12345,
      uploadTime: '2023-10-15',
      description: '这是一个示例视频的描述信息，可以介绍视频内容。',
      author: {
        id: 1,
        name: '视频作者',
        avatar: 'https://via.placeholder.com/50x50/4A90E2/FFFFFF?text=头像'
      }
    })
    
    // 返回上一页
    const goBack = () => {
      // 如果使用Vue Router
      router.back()
      // 如果不使用Vue Router，可以使用以下方法
      // window.history.back()
    }
    
    // 视频开始播放时触发
    const onPlay = () => {
      console.log('视频开始播放')
      // 可以在这里添加播放统计等逻辑
    }
    
    // 视频暂停时触发
    const onPause = () => {
      console.log('视频暂停')
    }
    
    // 视频播放结束时触发
    const onVideoEnded = () => {
      console.log('视频播放结束')
      // 可以在这里添加播放完成统计、自动播放下一个视频等逻辑
    }
    
    // 组件挂载后执行
    onMounted(() => {
      console.log('视频页面组件已挂载')
      // 可以在这里添加初始化逻辑，如获取视频数据
    })
    
    // 组件卸载前执行
    onUnmounted(() => {
      console.log('视频页面组件即将卸载')
      // 可以在这里添加清理逻辑，如暂停视频播放
      if (videoPlayer.value) {
        videoPlayer.value.pause()
      }
    })
    
    // 返回模板中需要使用的数据和方法
    return {
      videoPlayer,
      currentVideo,
      goBack,
      onPlay,
      onPause,
      onVideoEnded
    }
  }
}
</script>

<style scoped>
/* 视频页面容器样式 */
.video-page {
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  background-color: #fff;
  min-height: 100vh;
}

/* 页面头部样式 */
.video-header {
  display: flex;
  align-items: center;
  padding: 15px;
  border-bottom: 1px solid #e0e0e0;
  background-color: #fafafa;
}

/* 返回按钮样式 */
.back-btn {
  display: flex;
  align-items: center;
  background: none;
  border: none;
  font-size: 16px;
  color: #333;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.back-btn:hover {
  background-color: #f0f0f0;
}

.back-btn .icon {
  margin-right: 5px;
  font-size: 18px;
}

/* 页面标题样式 */
.page-title {
  flex: 1;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0;
  padding: 0 15px;
}

/* 视频播放器区域样式 */
.video-player-section {
  padding: 15px;
}

/* 视频容器样式 */
.video-container {
  position: relative;
  width: 100%;
  margin-bottom: 20px;
}

/* 视频播放器样式 */
.video-player {
  width: 100%;
  height: auto;
  max-height: 70vh;
  background-color: #000;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

/* 视频信息区域样式 */
.video-info {
  padding: 0 10px;
}

/* 视频元信息样式 */
.video-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

/* 作者信息样式 */
.author-info {
  display: flex;
  align-items: center;
}

/* 作者头像样式 */
.author-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 10px;
  object-fit: cover;
}

/* 作者详情样式 */
.author-details {
  display: flex;
  flex-direction: column;
}

/* 作者名称样式 */
.author-name {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin: 0 0 5px 0;
}

/* 视频统计数据样式 */
.video-stats {
  font-size: 14px;
  color: #666;
  margin: 0;
}

/* 视频描述样式 */
.video-description {
  padding: 15px 0;
  border-top: 1px solid #f0f0f0;
}

.video-description p {
  font-size: 14px;
  line-height: 1.5;
  color: #333;
  margin: 0;
}

/* 响应式设计 - 平板设备 */
@media (min-width: 768px) {
  .video-page {
    max-width: 900px;
  }
  
  .video-header {
    padding: 20px;
  }
  
  .page-title {
    font-size: 20px;
  }
  
  .video-player-section {
    padding: 20px;
  }
}

/*响应式设计 - 桌面设备 */
@media (min-width: 1024px) {
  .video-page {
    max-width: 500px;
  }
} 

</style>